import { ISingleOrder } from '@alberta/konexi-shared';
import { Inject, Injectable, NgZone } from '@angular/core';
import { SingleOrderChannel } from 'src/app/business/single-order/single-order-channel';
import { IAppController } from 'src/app/common/contracts/controller/app-controller';
import { IDispatcher } from 'src/app/common/contracts/dispatch/dispatcher';
import { IPlatformSync, PlatformSyncToken } from 'src/app/common/contracts/sync/platform-sync';
import { AppController } from 'src/app/common/controller/app-controller';
import { Dispatcher } from 'src/app/common/dispatch/dispatcher';

import { SingleOrderModelName } from '../../models/model-names';
import { SyncProgressEvent } from '../../models/sync-progress-event';
import { EventService } from '../event.service';
import { SyncService } from './sync.service';

@Injectable()
export class SingleOrderSyncService extends SyncService<ISingleOrder> {
  constructor(
    @Inject(AppController) appController: IAppController,
    @Inject(Dispatcher) dispatcher: IDispatcher<ISingleOrder>,
    eventService: EventService<SyncProgressEvent>,
    ngZone: NgZone,
    @Inject(PlatformSyncToken) platformSync: IPlatformSync
  ) {
    super(SingleOrderModelName, appController, dispatcher, eventService, ngZone, platformSync);
  }

  protected async afterPatch(entity: ISingleOrder): Promise<void> {
    await this.onPatched(entity);
  }

  public canSync(channel: string): boolean {
    return (
      channel === SingleOrderChannel.CREATE ||
      channel === SingleOrderChannel.EDIT ||
      channel === SingleOrderChannel.DELETE
    );
  }
}
